import { useMemo } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { clearFocusedAttribute } from '../../../redux/actions/focusedAttributeActions';
import { Modes } from '../../../redux/reducers/focusedAttributeReducer';

export function useFocusedAttribute(relevantMode: Modes) {
  const dispatch = useDispatch();

  const { mode, data: focusedAttribute } = useSelector(
    (state: RootStateOrAny) => state.FocusedAttributeReducer,
  );
  const attribute = useMemo(
    () => (mode === relevantMode ? focusedAttribute : undefined),
    [mode, focusedAttribute, relevantMode],
  );

  const handleClose = () => {
    dispatch(clearFocusedAttribute());
  };

  return { handleClose, attribute };
}
